// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM6.5 16.5H9.87793C10.1868 17.3739 11.0202 18 11.9999 18C12.9796 18 13.813 17.3739 14.1219 16.5H17.5V14.882L16.5 12.882V10.5C16.5 8.01472 14.4853 6 12 6C9.51472 6 7.5 8.01472 7.5 10.5V12.882L6.5 14.882V16.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-notification-circle-filled')
export default class NotificationCircleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'notification-circle-filled',
    }
  }
}
